<script setup lang="ts">
import type { LogoProps } from '../../models/Logo.model'
import { useTenantLogo } from '../../composables/useTenantLogo'
import { computed } from 'vue'

const { size = 'md' } = defineProps<LogoProps>()

const { hasTenantLogo } = useTenantLogo()

const logoSizes = {
  sm: 'w-auto max-h-8',
  md: 'w-auto max-h-12',
  lg: 'w-auto max-h-14',
}

const logoSize = computed(() => logoSizes[size])

const handleImageError = () => {
  hasTenantLogo.value = false
}
</script>

<template>
  <div class="flex items-start justify-center">
    <img
      :src="'/assets/logo.png'"
      :class="[logoSize]"
      alt="Company Logo"
      @error="handleImageError"
    />
  </div>
</template>
